import axios from 'axios';
import Vue from "vue";

//Here we maintain the reference to the ahID
let activeHotspotTrackId;
let isInteracting = false;

export async function trackInteractionEvents(eventType, store) {
    if (eventType === 'start') {
        store.getActiveHotspot.interacted = true;
        await handleStartInteraction(store);
    } else {
        if (isInteracting) {
            await handleEndInteraction(store);
        } else {
            isInteracting = true;
        }
    }
}

async function handleEndInteraction(store) {
    //Here we await for the ahID to be resolved, and then we make the request to end the interaction
    const currentAnalyticHotspotId = await activeHotspotTrackId;
    const params = {
        analyticHotspotID: currentAnalyticHotspotId,
        endTime: store.getTimeHotspotInteraction.interactionTimeStamp.format('YYYY/MM/DD hh:mm:ss'),
        isDebug: store.getIsDebug,
        seconds: store.getTimeHotspotInteraction.interactionElapsedTime,
        type: 'end',
        videoID: store.getVideoID,
        weblinkID: store.getWeblinkID,
    };

    try {
        const url = '/campaign/video/analytic/interactive/save';
        await makePostRequest(url, params);
    } catch (e) {
        console.log('response error');
    }
}

async function handleStartInteraction(store) {
    let parameter = store.getActiveHotspot.hotspotAction.parameter;
    let isPdfFile = false;
    if (parameter != null) {
        isPdfFile = parameter.includes('.pdf')
    }
    let permitDownload = 0;
    if (isPdfFile) {
        permitDownload = store.getActiveHotspot.hotspotAction.permitDownload;
    }

    const params = {
        hotspotID: store.getActiveHotspot.hotspotId,
        isDebug: store.getIsDebug,
        permitDownload: permitDownload,
        startTime: store.getTimeHotspotInteraction.interactionTimeStamp.format('YYYY/MM/DD hh:mm:ss'),
        type: 'start',
        videoID: store.getVideoID,
        weblinkID: store.getWeblinkID,
    };

    try {
        const url = '/campaign/video/analytic/interactive/save';
        const result = await makePostRequest(url, params);
        activeHotspotTrackId = result.data.ahID;
        if (isInteracting && activeHotspotTrackId > 0) {
            await handleEndInteraction(store);
            isInteracting = false;
        }
    } catch (e) {
        console.log('response error');
    }
}

async function makePostRequest(url, params) {
    return await axios.post(url, params, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
    })
}
